<template>
  <div class="page-content" id="newProductPandect">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item>监控产品</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="计划名称" :label-width="formLabelWidth">
          <el-input placeholder="请输入" v-model.trim="planname" autocomplete="on" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="平台" :label-width="formLabelWidth">
          <el-select v-model="platforms" filterable clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in platformList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监控产品" :label-width="formLabelWidth">
          <el-cascader
						size="small"
						v-model="productid"
						filterable
						clearable
						:filter-method="handleFilterMethod"
						:options="getShopProductsData"
						:props="cascaderProps"
            style="width: 100%;">
          </el-cascader>
        </el-form-item>
        <el-form-item label="通知人" :label-width="formLabelWidth">
          <el-select v-model="noticePeo" filterable clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in noticePeoData"
              :key="item.id"
              :label="item.nickname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top: -4px;">
          <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
        </el-form-item>
      </el-form>
    </section>

    <div class="page">
      <div class="downBtn" v-if="type.editStatus">
        <el-button size="small" type="primary" @click="newAdd" icon="el-icon-plus">新增</el-button>
        <el-button size="small" @click="onOpenDeleteDia(2)">批量删除</el-button>
        <el-button size="small" @click="batchEditing">批量编辑</el-button>
        <el-button size="small" @click="useUpdateStatus(1)">批量启用</el-button>
        <el-button size="small" @click="useUpdateStatus(0)">批量停用</el-button>
        <el-button size="small" @click="notifyPeo">批量设置通知人</el-button>
        <el-button size="small" @click="pushDialog = true" :disabled="pushDis">推送方式设置</el-button>
        <el-button size="small" @click="triggerPeo">管理通知人</el-button>
        <el-button size="small" @click="downDataClick" :loading="downloadLoading">下载数据</el-button>
      </div>
      <div class="downBtn" v-else>
        <el-button size="small" @click="downDataClick" :loading="downloadLoading">下载数据</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table
        @selection-change="handleSelectionChange"
        :data="tableData"
        ref="multipleTable"
        v-loading="dataLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @row-click="tableClick"
        style="width: 100%"
        :stripe= "true"
        >
        <el-table-column type="selection" min-width="3%">
        </el-table-column>

        <el-table-column label="序号" type="index" min-width="5%">
        </el-table-column>

        <el-table-column label="计划名称" min-width="18%">
          <template slot-scope="scope">
						<span>{{ scope.row.planname }}</span>
					</template>
        </el-table-column>

        <el-table-column label="监控平台" min-width="18%">
          <template slot-scope="scope">
            <div class="plat-item" v-for="(plat, index) in generatorPlatArr(scope.row.platform)" :key="index">
              {{ plat }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="产品型号" min-width="8%">
          <template slot-scope="scope">
            <el-popover placement="bottom" width="360" trigger="hover">
              <div style="max-height: 320px;overflow-y: auto">
                <div v-for="(text, i) in scope.row.product" :key="i" class="g-block" style="margin: 8px 0;">
                  {{ text }}
                </div>
              </div>
              <span slot="reference">
                {{ scope.row.product.length }}个
              </span>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="监控时间" min-width="10%">
          <template slot-scope="scope">
            <span>
              {{ scope.row.plathour }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="通知人" min-width="18%">
          <template slot-scope="scope">
            <span>
              {{ scope.row.noticeusername }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="计划状态" min-width="8%" v-if="type.editStatus">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status === 1 ? true : false"
              @change="(val) => onStatusChange(val, scope.row.id)"
              active-color="#408ae7"
              inactive-color="#d9d9d9"
              active-text="开"
              inactive-text="关"
              @click.stop.native>
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="12%" v-if="type.editStatus">
          <template slot-scope="scope">
            <div class="g-inline-block" style="color: #108cee;cursor: pointer;" @click.stop="editor(scope.row.id)">
              <i class="el-icon-edit-outline"></i>
              <span class="g-inline-block">编辑</span>
            </div>
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;" @click.stop="onOpenDeleteDia(1,scope.row.id)">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length >= 1">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <!-- 删除 -->
      <el-dialog
        title="提示"
        :visible.sync="deleteShow"
        width="360px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
            <div>
              <div style="font-size: 16px;">
                你确认要删除<span>{{delType}}</span>监控吗？
              </div>
              <div style="font-size: 14px;">删除后
                <span style="color: #e90e24;font-size: 14px;">
                  监控信息将会被彻底删除
                </span>
              </div>
            </div>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteClassification" size="small" :loading="ficationLoading">确 定</el-button>
          <el-button type="TheCustom" @click="delCancel" size="small" >取 消</el-button>
        </span>
      </el-dialog>
      <!-- 下载数据 -->
      <el-dialog
  			title="下载数据"
  			:visible.sync="downDataDialog"
  			:close-on-click-modal="false"
  			width="640px">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form label-width="100px">
  						<el-form-item label="监控计划" :required="true">
                <el-select v-model="downData.monitoring" size="small" clearable multiple placeholder="请选择" style="width: 440px;" @change="allShop">
                  <el-option
                    v-for="item in monOptions"
                    :key="item.id"
                    :label="item.planname"
                    :value="item.id"
                    :disabled="item.disabled">
                  </el-option>
                </el-select>
  						</el-form-item>
  						<el-form-item label="数据时间" :required="true">
                <el-radio-group v-model="downData.dataTime" style="width: 440px;">
                  <el-radio label="1">最近一次</el-radio>
                  <el-radio label="2">今日监控数据</el-radio>
                  <el-radio label="3">自定义时间</el-radio>
                </el-radio-group>
  						</el-form-item>
  						<el-form-item label="时间范围" v-if="downData.dataTime == '3'" :required="true">
                <el-date-picker
                  v-model="downData.searchformDate"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  range-separator="~"
                  :picker-options="pickerOptions"
                  size="small"
                  clearable
                  style="width: 440px;">
                </el-date-picker>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" class="g-confirm-btn" @click="download" :loading="downloadLoading">确 定</el-button>
  				<el-button size="small" class="g-cancel-btn" @click="downDataDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 批量设置通知人 -->
      <el-dialog
  			title="批量设置通知人"
  			:visible.sync="notifyDialog"
  			:close-on-click-modal="false"
  			width="640px">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form label-width="100px">
  						<el-form-item label="通知人">
                <el-select v-model="notify" size="small" clearable multiple placeholder="请选择" style="width: 440px;">
                  <el-option
                    v-for="item in noticePeoData"
                    :key="item.openid"
                    :label="item.nickname"
                    :value="item.openid">
                  </el-option>
                </el-select>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" class="g-confirm-btn" @click="notifyClick" :loading="notifyLoading">确 定</el-button>
  				<el-button size="small" class="g-cancel-btn" @click="notifyDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 推送方式设置 -->
      <el-dialog
  			title="推送方式设置"
  			:visible.sync="pushDialog"
  			:close-on-click-modal="false"
  			width="640px">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form>
  						<el-form-item :required="true">
                <el-radio v-model="pushmode" label="1">每个监控计划完成后，推送本次监控的结果。</el-radio>
                <el-radio v-model="pushmode" label="3">每个监控计划完成后，只推送本次监控的{{ $store.state.globalLowPrice }}结果。</el-radio>
                <el-radio v-model="pushmode" label="2">每日监控计划全部完成时，推送全天监控的结果。</el-radio>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" class="g-confirm-btn" @click="pushClick" :loading="pushLoading">确 定</el-button>
  				<el-button size="small" class="g-cancel-btn" @click="pushDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 管理通知人 -->
      <administrativeNotifier ref="childDialog" />

      <!-- 批量启用、停用 -->
      <el-dialog title="提示" :visible.sync="useShow" width="360px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
              <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
             <div>
                 <div style="font-size: 16px;">你确认要{{useData}}{{openNumber}}监控吗？</div>
                 <div style="font-size: 14px;">{{useData}}后
                 <span style="color: #e90e24;font-size: 14px;" v-if="useData == '启用'">监控计划将会正常被执行</span>
                 <span style="color: #e90e24;font-size: 14px;" v-if="useData != '启用'">监控计划将不会被执行</span>
              </div>
             </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="useSure" size="small">确 定</el-button>
            <el-button @click="useShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
          </span>
      </el-dialog>
      <!-- 批量启用、停用  -->

      <!-- 批量编辑 -->
      <el-dialog title="批量编辑" :visible.sync="editShow" width="550px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
            <el-form label-width="130px">
              <el-form-item label="监控时间：" :required="true">
                <el-select
                  size="small"
                  v-model="plathour"
                  multiple
                  placeholder="请选择"
                  :multiple-limit="limitMonitorTimeNum"
                >
                  <el-option
                    v-for="item in time"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <span style="padding-left: 15px;color: #FAAD14;">
                  可设置{{limitMonitorTimeNum}}个监控时间
                </span>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="editSure" size="small">确 定</el-button>
            <el-button @click="editShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
          </span>
      </el-dialog>
      <!-- 批量编辑 -->
    </div>
  </div>
</div>

</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import administrativeNotifier from "./administrativeNotifier";
import { mapGetters } from 'vuex';
  export default {
    data() {
      return {
        limitMonitorTimeNum: 1,
        plathour: [],
        editShow: false,
        time: [],
        useData: '启用',
        useShow: false,
        pushDis: true,
        getShopProductsData: [],
        productid: '',
        noticePeo: '',
        noticePeoData: [],
        pushDialog: false,
        pushLoading: false,
        pushmode: '2',
        notifyDialog: false,
        notifyLoading: false,
        notify: [],
        cascaderProps: {
          value: 'id',
          label: 'productClassifyName'
        },
        monOptions: [],
        downDataDialog: false,
        downloadLoading: false,
        downData: {
          monitoring: [],
          dataTime: '1',
          searchformDate: [],
        },
        delType: '',
        checkAll: '',
        ficationLoading: false,
        deleteShow: false,
        dataLoading: false,
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        tableData: [],
        selectRows: [],
        searchformDate: [],
        delIds: [],
        platformList: [
  				{ value: 'TB', label: '淘宝' },
  				{ value: 'TM', label: '天猫' },
  				{ value: 'JD', label: '京东' },
          { value: 'SN', label: '苏宁' },
          { value: '1688', label: '1688' },
          { value: 'DD', label: '当当' },
  				{ value: 'PDD', label: '拼多多' },
  			],
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
        totalNum: 100,
        formLabelWidth: '100px',
        openNumber: 0,
        platforms: '',
        planname: '',

        user_name: '',
        type: '',
        useStatus: '',
        userData: JSON.parse(localStorage.getItem('userData')),
        type: {}
      }
    },
    
    mounted() {
      this.type = JSON.parse(window.localStorage.userData)
      fetch({
  			url: 'hcm/cus/selectbmcSetting'
  		}).then(res => {
  			if(res.status === '10000') {
  				this.limitMonitorTimeNum = res.data.productmonitorFrequency === 1 ? 2 : 1;
          this.userid = res.data.bmcid
  			}
  		})
      this.getListBybmcid()
      this.theQuery()
      this.getWecharList()
      // 获取监控时间
      this.generateMonitorTime()
    },
    methods: {
      // 根据监控店铺是否是checkAll禁用其他店铺
      allShop() {
        let disabledShow
        for (let a in this.downData.monitoring) {
          if (this.downData.monitoring[a] === 'checkAll') {
            disabledShow = true
          } else {
            disabledShow = false
          }
        }
        for (let c in this.monOptions) {
          if (this.monOptions[c].id === 'checkAll' && disabledShow) {
            this.monOptions[c].disabled = false
            this.downData.monitoring = []
            this.downData.monitoring.push("checkAll")
          } else if (!disabledShow) {
            this.monOptions[c].disabled = false
          } else {
            this.monOptions[c].disabled = true
          }
        }
      },
      // 确认批量修改
      editSure() {
        if (this.plathour.length == 0) {
          this.$message({
            message: '请选择监控时间',
            type: 'warning'
          });
          return
        }
        let params = {
          ids: this.delIds,
          plathour: this.plathour.join(',')
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/updatePlathour",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.editShow = false
            this.theQuery();
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      // 生成0 - 24点的时间
      generateMonitorTime() {
  			let res = [];
  			for(let i = 0; i <= 23;i++) {
          if (i <= 9) {
            res.push(`0${i}:00`)
          } else {
            res.push(`${i}:00`)
          }
  			}
  			this.time = res;
  		},
      // 批量编辑
      batchEditing() {
        if (this.checkAll == 2) {
          this.delType = '全部'
          this.delIds = "checkAll"
        } else {
          let arrIds = []
          for (let i in this.selectRows) {
            arrIds.push(this.selectRows[i].id)
          }
          this.delIds = arrIds.join(',')
        }
        console.log(this.delIds)
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.editShow = true
      },
      // 批量启用
      useUpdateStatus(e) {
        if (e == 1) {
          this.useData = '启用'
          this.useStatus = 1
        } else {
          this.useData = '停用'
          this.useStatus = 0
        }
        if (this.checkAll == 2) {
          this.openNumber = '勾选的全部'
        } else {
          this.openNumber = '勾选的' + this.selectRows.length + '项'
        }
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        this.delIds = arrIds.join(',')
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.useShow = true
      },
      // 确认
      useSure() {
        let params = {
          status: this.useStatus,
          id: this.delIds
        }
        if (this.platforms) {
          params.platforms = this.platforms
        }
        if (this.planname) {
          params.planname = this.planname
        }
        if (this.noticePeo) {
          params.noticeuserid = this.noticePeo
        }
        if (this.productid) {
          params.productid = this.productid[1].split(',')[0]
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/updateStatus",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.useShow = false
            this.theQuery();
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },

      // 新增
      newAdd() {
        this.$router.push(
          {
            name:'monitoringProducts',
            query: {pushmode:this.pushmode}
          }
        )
      },
      // 下载数据获取监控计划
      downDataClick() {
        let params={
          pageNo: 1,
          pageSize: 10000,
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/getPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            console.log(data)
            this.monOptions = []
            this.monOptions.push({
              id: 'checkAll',
              planname: '全部监控计划'
            })
            for (let a in data.content) {
              this.monOptions.push(data.content[a])
            }
            this.downData.monitoring = []
            this.downData.dataTime = '1'
            this.downDataDialog = true
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      getListBybmcid() {
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getShopProductsData = data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      handleFilterMethod(node, keyword) {
        return node.text.toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
      },
      // table点击
      tableClick(row) {
        console.log(row)
        this.$router.push({name:'MonitorDetails',query: {id:row.id, planname:row.planname, platform:row.platform, noticeusername:row.noticeusername}})
      },
      // 编辑
      editor(id) {
        this.$router.push({name:'monitoringProducts',query: {id:id,pageNo:this.pageNo,pageSize:this.pageSize}})
      },
      // 管理通知人
      triggerPeo() {
        this.$refs.childDialog.theTrigger(this.userData.bmcid);
      },
      // 时间范围
      getRecentDate(picker,n){
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.searchformDate[0] = this.$options.filters['fullTime'] (end).substring(0,10);
          this.searchformDate[1] = this.$options.filters['fullTime'] (end).substring(0,10);
        } else {
          this.searchformDate[0] = this.$options.filters['fullTime'] (start).substring(0,10);
          this.searchformDate[1] = this.$options.filters['fullTime'] (end).substring(0,10);
        }
  		},
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery()
      },
      // 翻页
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery()
      },
      // 数据源
      theQuery() {
        this.dataLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.platforms) {
          params.platforms = this.platforms
        }
        if (this.planname) {
          params.planname = this.planname
        }
        if (this.noticePeo) {
          params.noticeuserid = this.noticePeo
        }
        if (this.productid) {
          params.productid = this.productid[1].split(',')[0]
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/getPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dataLoading = false
            this.tableData = res.data.content
            if (this.tableData.length > 0) {
              this.pushDis = false
              // 2021.1.25   LJ  数字类型转成字符串
              this.pushmode = this.tableData[0].pushmode.toString()
            } else {
              this.pushDis = true
              this.pushmode = 2
            }
            this.totalNum = res.data.totalElements
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 通知人微信数据
      getWecharList() {
        fetch({
          url: "hcm/hcmNewMonitorProduct/getWecharList",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.noticePeoData = res.data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 平台数据处理
      generatorPlatArr(platform) {
  			if(this.tableData.length) {
  				let platforms = platform.split(',');
  				return platforms.reduce((res, cur) => {
  					let item = this.platformList.find(p => p.value === cur);
            if (item && item.label) {
              res.push(item.label);
    					return res;
            }
  				}, [])
  			}else {
  				return []
  			}
  		},
      // 监控状态
      onStatusChange(val, id) {
        this.useShow = true
        if (val == 1) {
          this.useData = '启用'
          this.useStatus = 1
        } else {
          this.useData = '停用'
          this.useStatus = 0
        }
        this.openNumber = '该'
        this.delIds = id
  		},
      // 序号勾选
      handleSelectionChange(val) {
        this.openNumber = val.length;
        this.selectRows = val;
      },
      // 勾选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      // 删除
      onOpenDeleteDia(e,ids) {
        this.delIds = ''
        if (ids && e == 1) {
          this.delType = '该'
          this.delIds = ids
        } else if (this.checkAll == 2 && e == 2) {
          this.delType = '全部'
          this.delIds = "checkAll"
        } else {
          this.delType = this.openNumber + '条'
          let arrIds = []
          for (let i in this.selectRows) {
            arrIds.push(this.selectRows[i].id)
          }
          this.delIds = arrIds.join(',')
        }
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.deleteShow = true
      },
      // 取消删除
      delCancel() {
        this.deleteShow = false
        this.delType = ''
        this.checkAll = ''
        this.delIds = ''
      },
      // 确认删除
      deleteClassification() {
        this.ficationLoading = true
        let params = {
          ids: this.delIds
        }
        fetch({
          url: "/hcm/hcmNewMonitorProduct/delete",
          method: "post",
          data: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.ficationLoading = false
            this.deleteShow = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.theQuery();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 下载数据
      download() {
        if (this.downData.monitoring.length == 0) {
          this.$message({
            message: '请选择监控计划',
            type: 'warning'
          });
          return;
        }
        if (this.downData.dataTime === '3' && this.downData.searchformDate.length == 0) {
          this.$message({
            message: '请选择时间',
            type: 'warning'
          });
          return;
        }
        this.downloadLoading = true
        let planid = []
        let planidShow
        for (let a in this.downData.monitoring) {
          if (this.downData.monitoring[a] === 'checkAll') {
            planidShow = true
          }
        }
        if (planidShow) {
          for (let b in this.monOptions) {
            if (this.monOptions[b].id != 'checkAll') {
              planid.push(this.monOptions[b].id)
            }
          }
        } else {
          planid = this.downData.monitoring
        }
        let params = {
          planid: planid.join(','),
          type: this.downData.dataTime,
        };
        if (this.downData.dataTime === '2') {
          this.getRecentDate('',1)
          console.log(this.searchformDate)
          params.starttime = this.searchformDate[0]
          params.endtime = this.searchformDate[1]
        }
        if (this.downData.dataTime === '3') {
          params.starttime = this.$options.filters['fullTime'] (this.downData.searchformDate[0]).substring(0,10)
          params.endtime = this.$options.filters['fullTime'] (this.downData.searchformDate[1]).substring(0,10)
        }
        fetch({
          url: "hcm/hcmProductMonitor/downloadProductMonitorList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          this.downDataDialog = false
          //下载
          let that = this
          let data
          if (res.type === 'application/json') {
              let reader = new FileReader();
              reader.readAsText(res, 'utf-8');
              reader.onload = function (e) {
                data = JSON.parse(reader.result)
                console.log(data);
                that.$message({
                  message: data.message,
                  type: 'warning'
                });
                that.downloadLoading = false
                return;
              }
          } else {
            let url = window.URL.createObjectURL(new Blob([res]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "监控产品.xlsx");
            document.body.appendChild(link);
            link.click();
            this.downloadLoading = false

          }
        });
      },
      notifyPeo() {
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        if (arrIds.length == 0) {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return;
        }
        this.notifyDialog = true
      },
      // 确认批量设置通知人
      notifyClick() {
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        // if (this.notify.length == 0) {
        //   this.$message({
        //     message: '请选择通知人',
        //     type: 'warning'
        //   });
        //   return;
        // }
        console.log(arrIds)
        this.notifyLoading = true
        let params = {
          ids: arrIds.join(','),
          noticeuseridUp: this.notify.join(','),
        }
        if (this.platforms) {
          params.platforms = this.platforms
        }
        if (this.planname) {
          params.planname = this.planname
        }
        if (this.noticePeo) {
          params.noticeuserids = this.noticePeo
        }
        if (this.productid) {
          params.productid = this.productid[1].split(',')[0]
        }
        fetch({
          url: "/hcm/hcmNewMonitorProduct/updateNoticeuser",
          method: "post",
          data: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.notifyLoading = false
            this.notifyDialog = false
            this.theQuery()
            this.getWecharList()
          } else {
            this.$message.error(res.message);
          }
        })


      },
      // 确认推送方式设置
      pushClick() {
        this.pushLoading = true
        let params = {
          pushmode: this.pushmode
        }
        fetch({
          url: "/hcm/hcmNewMonitorProduct/updatePushmode",
          method: "post",
          data: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.pushLoading = false
            this.pushDialog = false
            this.theQuery()
            this.getWecharList()
          } else {
            this.$message.error(res.message);
          }
        })
      },
    },
    components: {
      pagination,administrativeNotifier
    }
  }
</script>
<style lang="scss">
  #newProductPandect{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }
    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .downBtn {
      display: flex;
      justify-content: flex-start;
    }
    .prompt {
      height: 28px;
      border: 1px solid #108cee;
      background-color: #e6f7ff;
      border-radius: 5px;
      line-height: 28px;
      margin-top: 8px;
      margin-bottom: 8px;
    }
    .promptFont{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
    }
    .promptFont2{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
      cursor: pointer;
    }
    .plat-item {
    	display: inline-block;
    	margin-left: 5px;
    	border: 1px solid rgb(164, 163, 163);
    	padding: 2px;
      border-radius: 4px;
    }
  }
  @import "style/activityDeclaration.scss";
</style>
